module.exports = __webpack_public_path__ + "img/centro5.422e62a8.jpg";